<template>
    <div id="secondarycampaignCopy" v-if="labelTextArray.length > 0">
        <template v-if="type == typeEnum.SingleText">
            <span v-html="labelTextArray[0].text"></span>
        </template>
        <template v-else-if="type == typeEnum.MultipleTextWithLabel">
            <div v-for="item in labelTextArray" :key="item.label" class="secondary-campaign-copy-attr-div">
                <b v-html="item.label" class="secondary-campaign-copy-label"></b>:
                <span v-html="item.text" class="secondary-campaign-copy-text"></span>
            </div>
        </template>
    </div>
</template>
<script lang="ts">
import Vue, { defineComponent, PropType } from 'vue'
import secondaryAdCopyTypeEnum from '../common/SecondaryAdCopyTypeEnum'

export default defineComponent({
    props:{
        labelTextArray: Array as PropType<LabelTextObj[]>,
        type: String
    },
    data() {
        return {
            typeEnum: secondaryAdCopyTypeEnum
        }
    }
})
</script>